<template>
  <component
    :is="'script'"
    src="https://www.google.com/recaptcha/api.js?render=6LdmLnojAAAAAHadYEvCC2LgrLHiE8Xsay6U_Pmo"
  />
  <Container class="items-center">
    <ErrorBanner v-if="healthcheckStore.hasError" class="w-full md:w-1/3 mx-auto" />
    <div class="p-4 bg-white rounded-xl shadow-xl w-full md:w-1/2 md:mt-20 mt-4">
      <template v-if="flowStatus === FlowStatus.CREATING">
        <template v-if="isInvitationTokenBad">
          <Title>Napačen žeton</Title>
          <p>Kontaktirajte nadrejenega v podjetju</p>
        </template>
        <template v-else>
          <div class="tile px-6 py-6 lg:px-8 py-6 mb-8">
            <Title v-if="!isInvitationRegistration" subtitle> Kreirajte poslovni račun </Title>
            <Title v-if="isInvitationRegistration" subtitle>
              Povežite se v podjetje {{ model.companyName }}
            </Title>
            <form method="post" class="w-full" @submit="submitData">
              <div class="grid grid-cols-1 gap-x-6 gap-y-8 mt-4 sm:grid-cols-6">
                <div class="col-span-6 lg:col-span-3">
                  <label>Ime osebe</label>
                  <div class="mt-2">
                    <Input
                      id="name"
                      v-model="model.name"
                      type="text"
                      placeholder="Janez Novak"
                      class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-green-main sm:leading-6"
                      required
                      autofocus
                    />
                  </div>
                </div>
                <div class="col-span-6 lg:col-span-3">
                  <label>Naziv podjetja</label>
                  <div class="mt-2">
                    <Input
                      id="companyName"
                      v-model="model.companyName"
                      type="text"
                      class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-green-main sm:leading-6"
                      :disabled="isInvitationRegistration"
                      required
                    />
                  </div>
                </div>
                <div class="col-span-6">
                  <label>Elektronski naslov</label>
                  <div class="mt-2">
                    <Input
                      id="email"
                      v-model="model.email"
                      type="email"
                      class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-green-main sm:leading-6"
                      placeholder="janez.novak@gmail.com"
                      required
                    />
                  </div>
                </div>
                <template v-if="emailErrors.length">
                  <p
                    v-for="(err, idx) in emailErrors"
                    :key="idx"
                    class="sm:col-span-6 -mt-4 text-red-600"
                  >
                    {{ err }}
                  </p>
                </template>
                <div class="col-span-6 lg:col-span-3">
                  <label>Geslo</label>
                  <div class="mt-2">
                    <Input
                      id="password"
                      v-model="model.password1"
                      type="password"
                      class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-green-main sm:leading-6"
                      placeholder="Močno geslo"
                      required
                    />
                  </div>
                </div>
                <ul
                  v-if="passwordErrors.length"
                  class="sm:col-span-6 -mt-4 text-red-600 list-disc ml-5"
                >
                  <li v-for="(err, idx) in passwordErrors" :key="idx">
                    {{ err }}
                  </li>
                </ul>
                <div class="col-span-6 lg:col-span-3">
                  <label>Potrdi geslo</label>
                  <div class="mt-2">
                    <Input
                      id="passwordConfirm"
                      v-model="model.password2"
                      type="password"
                      class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-green-main sm:leading-6"
                      placeholder="Močno geslo"
                      required
                    />
                  </div>
                </div>
                <div
                  v-if="
                    model.password1.length < 8 ||
                    ((model.password1.length || model.password2.length) && !arePasswordsEqual)
                  "
                  class="col-span-6"
                >
                  <span>Zahteve za geslo</span>
                  <ul class="text-black-600 list-disc ml-5">
                    <li v-if="model.password1.length < 8">Geslo mora vsebovati vsaj 8 znakov</li>
                    <li
                      v-if="
                        (model.password1.length || model.password2.length) && !arePasswordsEqual
                      "
                    >
                      Gesli se morata ujemati
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-span-6 mt-5">
                <Cbox v-model="model.agree_to_terms"
                  >Strinjam se s
                  <a
                    href="https://www.kroznik.si/pogoji-poslovanja-partner"
                    class="text-green-main hover:underline cursor-pointer hover:text-green-dark transition duration-150"
                    target="_blank"
                    >pogoji poslovanja za partnerje</a
                  >
                </Cbox>
              </div>
              <Button
                type="submit"
                class="w-full mt-8 hover:cursor-pointer"
                data-testid="createAccountButton"
                :disabled="model.agree_to_terms !== true"
              >
                Kreiraj račun
              </Button>
            </form>
            <p
              v-for="(err, idx) in registerErrors"
              :key="idx"
              class="sm:col-span-6 mt-4 text-red-600"
            >
              {{ err }}
            </p>
          </div>
          <hr class="" >
          <GoogleRecaptchaTerms class="mb-2" />
        </template>
      </template>
      <template v-else>
        <h1
          class="text-3xl mt-8 font-bold text-primary-600 text-center"
          data-testid="successfulAccountCreation"
        >
          Poslovni račun je bil uspešno kreiran.
        </h1>
        <h2 class="text-center my-5 mx-5">
          Na vaš elektronski naslov smo poslali sporočilo za potrditev elektronskega naslova.
        </h2>
      </template>
    </div>
    <div class="mt-4 text-center">
      <p>
        Že imaš račun?
        <span>
          <Anchor :href="Routes.Home" class="hover:text-primary-200 font-bold"> Vpiši se </Anchor>
        </span>
      </p>
    </div>
  </Container>
</template>

<script lang="ts" setup>
import type { AxiosError } from 'axios'
import Container from '~/components/common/Container.vue'
import Button from '~/components/common/Button.vue'
import Title from '~/components/common/Title.vue'
import Input from '~/components/common/Input.vue'
import type {
  CustomRegister} from '~/client_api';
import {
  AccountTypeEnum,
  AuthApi,
  CompanyMembersApi,
  Configuration
} from '~/client_api'
import { axiosInstance } from '~/client_api/exios'
import { Routes } from '~/routing/routes'
import GoogleRecaptchaTerms from '~/components/GoogleRecaptchaTerms.vue'
import Cbox from '~/components/common/Cbox.vue'
import Anchor from '~/components/common/Anchor.vue'
import ErrorBanner from '~/components/features/ErrorBanner.vue'
import { useHealthcheckStore } from '~/stores/healthcheck'

const route = useRoute()

const healthcheckStore = useHealthcheckStore()

definePageMeta({
  layout: 'public',
  middleware: ['auth'],
})

const model: CustomRegister = reactive({
  email: '',
  password1: '',
  password2: '',
  name: '',
  recaptchaToken: '',
  accountType: AccountTypeEnum.Company,
  companyName: '',
  invitation_token: null,
  agree_to_terms: false,
})
const registerErrors: string[] = reactive([])
const emailErrors: string[] = reactive([])
const passwordErrors: string[] = reactive([])
const arePasswordsEqual = computed(() => {
  return model.password1 === model.password2
})

const enum FlowStatus {
  CREATING,
  FINISHED,
}

const flowStatus = ref(FlowStatus.CREATING)

const submitData = (e: any) => {
  clearForLoginRequest()
  e.preventDefault()
  grecaptcha.ready(function () {
    grecaptcha
      .execute('6LdmLnojAAAAAHadYEvCC2LgrLHiE8Xsay6U_Pmo', {
        action: 'submit',
      })
      .then(function (token: string) {
        model.recaptchaToken = token
        new AuthApi(new Configuration(), '', axiosInstance)
          .authDjRegistrationCreate({ ...model })
          .then(() => {
            flowStatus.value = FlowStatus.FINISHED
          })
          .catch((err: AxiosError) => {
            const data = err.response.data
            if (err?.response.status === 400) {
              if (data?.non_field_errors?.length) {
                registerErrors.push(...data.non_field_errors)
              }
              if (data?.email?.length) {
                emailErrors.push(...data.email)
              }
              if (data?.password1?.length) {
                passwordErrors.push(...data.password1)
              }
            }
          })
      })
  })
}

const clearForLoginRequest = (): void => {
  registerErrors.splice(0)
  emailErrors.splice(0)
  passwordErrors.splice(0)
}

const isInvitationRegistration = ref(false)
const isInvitationTokenBad = ref(false)
onMounted(async () => {
  if (route.query?.token) {
    isInvitationRegistration.value = true
    try {
      const response = await new CompanyMembersApi(
        new Configuration(),
        '',
        axiosInstance
      ).getCompanyInfo(route.query.token)
      model.companyName = response.data.company_name
      model.invitation_token = route.query?.token
    } catch (e) {
      isInvitationTokenBad.value = true
    }
  }
})
</script>

<style scoped></style>
